import PaymentStatusDotView from './PaymentStatusDotView'

export default PaymentStatusDotView
